import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg
      ref={ref}
      onClick={onClick}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      className={className}
      fill='transparent'
      data-testid='copy-button-svg'>
      <path
        d='M17.3842 9.98096H11.327C10.5836 9.98096 9.98096 10.5836 9.98096 11.327V17.3842C9.98096 18.1276 10.5836 18.7302 11.327 18.7302H17.3842C18.1276 18.7302 18.7302 18.1276 18.7302 17.3842V11.327C18.7302 10.5836 18.1276 9.98096 17.3842 9.98096Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.28884 14.0191H6.61582C6.25883 14.0191 5.91645 13.8772 5.66402 13.6248C5.41159 13.3724 5.26978 13.03 5.26978 12.673V6.61582C5.26978 6.25883 5.41159 5.91645 5.66402 5.66402C5.91645 5.41159 6.25883 5.26978 6.61582 5.26978H12.673C13.03 5.26978 13.3724 5.41159 13.6248 5.66402C13.8772 5.91645 14.0191 6.25883 14.0191 6.61582V7.28884'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
